module.exports = __webpack_public_path__ + "img/osint-white.6c4bc3a8.png";